function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import BtnMixin from '../../mixins/btn.js';
import AttrsMixin from '../../mixins/attrs.js';
import QIcon from '../icon/QIcon.js';
import QBtn from '../btn/QBtn.js';
import QBtnGroup from '../btn-group/QBtnGroup.js';
import QMenu from '../menu/QMenu.js';
import { slot } from '../../utils/slot.js';
import { stop } from '../../utils/event.js';
import cache from '../../utils/cache.js';
export default Vue.extend({
  name: 'QBtnDropdown',
  mixins: [BtnMixin, AttrsMixin],
  inheritAttrs: false,
  props: {
    value: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      "default": 'bottom end'
    },
    menuSelf: {
      type: String,
      "default": 'top end'
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean
  },
  data: function data() {
    return {
      showing: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.$refs.menu !== void 0 && this.$refs.menu[val ? 'show' : 'hide']();
    },
    split: function split() {
      this.hide();
    }
  },
  render: function render(h) {
    var _this = this;

    var label = slot(this, 'label', []);
    var attrs = {
      'aria-expanded': this.showing === true ? 'true' : 'false',
      'aria-haspopup': 'true'
    };

    if (this.disable === true || this.split === false && this.disableMainBtn === true || this.disableDropdown === true) {
      attrs['aria-disabled'] = 'true';
    }

    var Arrow = [h(QIcon, {
      props: {
        name: this.dropdownIcon || this.$q.iconSet.arrow.dropdown
      },
      "class": 'q-btn-dropdown__arrow' + (this.showing === true && this.noIconAnimation === false ? ' rotate-180' : '') + (this.split === false ? ' q-btn-dropdown__arrow-container' : '')
    })];
    this.disableDropdown !== true && Arrow.push(h(QMenu, {
      ref: 'menu',
      props: {
        cover: this.cover,
        fit: true,
        persistent: this.persistent,
        noRouteDismiss: this.noRouteDismiss,
        autoClose: this.autoClose,
        anchor: this.menuAnchor,
        self: this.menuSelf,
        offset: this.menuOffset,
        contentClass: this.contentClass,
        contentStyle: this.contentStyle,
        separateClosePopup: true
      },
      on: cache(this, 'menu', {
        'before-show': function beforeShow(e) {
          _this.showing = true;

          _this.$emit('before-show', e);
        },
        show: function show(e) {
          _this.$emit('show', e);

          _this.$emit('input', true);
        },
        'before-hide': function beforeHide(e) {
          _this.showing = false;

          _this.$emit('before-hide', e);
        },
        hide: function hide(e) {
          _this.$emit('hide', e);

          _this.$emit('input', false);
        }
      })
    }, slot(this, 'default')));

    if (this.split === false) {
      return h(QBtn, {
        "class": 'q-btn-dropdown q-btn-dropdown--simple',
        props: _objectSpread(_objectSpread({}, this.$props), {}, {
          disable: this.disable === true || this.disableMainBtn === true,
          noWrap: true,
          round: false
        }),
        attrs: _objectSpread(_objectSpread({}, this.qAttrs), attrs),
        on: cache(this, 'nonSpl', {
          click: function click(e) {
            _this.$emit('click', e);
          }
        })
      }, label.concat(Arrow));
    }

    var Btn = h(QBtn, {
      "class": 'q-btn-dropdown--current',
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        disable: this.disable === true || this.disableMainBtn === true,
        noWrap: true,
        iconRight: this.iconRight,
        round: false
      }),
      attrs: this.qAttrs,
      on: cache(this, 'spl', {
        click: function click(e) {
          stop(e); // prevent showing the menu on click

          _this.hide();

          _this.$emit('click', e);
        }
      })
    }, label);
    return h(QBtnGroup, {
      props: {
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        push: this.push,
        unelevated: this.unelevated,
        glossy: this.glossy,
        stretch: this.stretch
      },
      staticClass: 'q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item'
    }, [Btn, h(QBtn, {
      staticClass: 'q-btn-dropdown__arrow-container q-anchor--skip',
      attrs: attrs,
      props: {
        disable: this.disable === true || this.disableDropdown === true,
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        push: this.push,
        size: this.size,
        color: this.color,
        textColor: this.textColor,
        dense: this.dense,
        ripple: this.ripple
      }
    }, Arrow)]);
  },
  methods: {
    toggle: function toggle(evt) {
      this.$refs.menu && this.$refs.menu.toggle(evt);
    },
    show: function show(evt) {
      this.$refs.menu && this.$refs.menu.show(evt);
    },
    hide: function hide(evt) {
      this.$refs.menu && this.$refs.menu.hide(evt);
    }
  },
  mounted: function mounted() {
    this.value === true && this.show();
  }
});